<template>
  <div id="trial">
    <v-layout justify-center>
      <v-card min-width="800px">
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>算算保费</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>-->
        </v-toolbar>

        <v-card-text>
          <v-layout row wrap>
            <!-- <div class="subheading pa-3">被保险人信息</div> -->
            <h4 class="pa-3">被保险人信息</h4>
          </v-layout>
          <v-layout row>
            <v-flex shrink pa-3 pr-5>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="164px"
              >
                <v-text-field
                  slot="activator"
                  v-model="date"
                  label="出生日期"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="date"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                  locale="zh-cn"
                  @change="save"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex shrink pa-3 pr-5>
              <v-select :items="sex" class="form-item" label="性别" @change="sexChange"></v-select>
              <!-- <v-radio-group v-model="sex" row label="性别">
          <v-radio label="男" value="男"></v-radio>
          <v-radio label="女" value="女"></v-radio>
              </v-radio-group>-->
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout column>
            <v-flex>
              <h4 class="pa-3">保障方案</h4>
              <p class="pa-3">终身重大疾病保险</p>
            </v-flex>
            <!-- <div class="pa-3">
        <h4>保障方案</h4>
        <p class="body-1">终身重大疾病保险</p>
            </div>-->
          </v-layout>
          <v-layout row>
            <v-flex shrink pa-3>
              <v-select
                :items="coverage"
                v-model="selectCoverage"
                class="form-item"
                label="保额(单位：万元)"
                @change="coverageChange"
              ></v-select>
            </v-flex>
            <p></p>
            <v-flex shrink pa-3>
              <v-select
                :items="payment"
                v-model="selectPayment"
                item-text="name"
                item-value="value"
                class="form-item"
                label="交费期限"
                @change="paymentChange"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md4>
              <div>
                保费
                <span class="headline primary-text">￥{{ price }}</span>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-container>
            <v-layout row wrap>
              <div class="subheading pa-3">团体费用补偿医疗保险</div>
            </v-layout>
            <v-layout row>
              <v-flex shrink pa-3 pr-5>
                <v-select
                  :items="addCoverage"
                  class="form-item"
                  label="保额(单位：万元)"
                  item-text="name"
                  item-value="value"
                  @change="addCoverageChange"
                  :disabled="isdisabled"
                ></v-select>
              </v-flex>
              <p></p>
              <v-flex shrink pa-3 pr-5>
                <v-select
                  :items="social"
                  class="form-item"
                  item-text="name"
                  item-value="value"
                  label="社保"
                  @change="SocialChange"
                  :disabled="isdisabled"
                ></v-select>
                <!-- <v-radio-group v-model="social" row label="社保">
          <v-radio label="有社保" value="1"></v-radio>
          <v-radio label="无社保" value="0"></v-radio>
                </v-radio-group>-->
              </v-flex>
            </v-layout>
            <v-layout>
              <v-spacer></v-spacer>
              <v-flex xs12 sm5 md4>
                <div>
                  保费
                  <span class="headline primary-text">￥{{ addprice }}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      ss: "男",
      price: "--------",
      addprice: "--------",
      sex: ["男", "女"],
      selectSex: null,
      menu: false,
      date: null,
      isdisabled: false,
      selectCoverage: null,
      coverage: [],
      coverages: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 66],
      coverageByAge: [
        {
          minAge: 0,
          maxAge: 10,
          minCoverage: 5,
          maxCoverage: 20
        },
        {
          minAge: 11,
          maxAge: 18,
          minCoverage: 5,
          maxCoverage: 50
        },
        {
          minAge: 18,
          maxAge: 40,
          minCoverage: 5,
          maxCoverage: 66
        },
        {
          minAge: 41,
          maxAge: 45,
          minCoverage: 5,
          maxCoverage: 45
        },
        {
          minAge: 46,
          maxAge: 50,
          minCoverage: 5,
          maxCoverage: 30 //28
        },
        {
          minAge: 51,
          maxAge: 55,
          minCoverage: 5,
          maxCoverage: 20
        },
        {
          minAge: 56,
          maxAge: 65,
          minCoverage: 5,
          maxCoverage: 15 //12
        }
      ],
      payment: [],
      selectPayment: null,
      paymentByAge: [
        {
          minAge: 0,
          maxAge: 40,
          payments: [
            { name: "一次交清", value: 1 },
            { name: "3年", value: 3 },
            { name: "5年", value: 5 },
            { name: "10年", value: 10 },
            { name: "20年", value: 20 },
            { name: "30年", value: 30 }
          ]
          // payments: [1, 3, 5, 10, 20, 30]
        },
        {
          minAge: 41,
          maxAge: 45,
          payments: [
            { name: "一次交清", value: 1 },
            { name: "3年", value: 3 },
            { name: "5年", value: 5 },
            { name: "10年", value: 10 },
            { name: "20年", value: 20 }
          ]
          // payments: [1, 3, 5, 10, 20]
        },
        {
          minAge: 46,
          maxAge: 55,
          payments: [
            { name: "一次交清", value: 1 },
            { name: "3年", value: 3 },
            { name: "5年", value: 5 },
            { name: "10年", value: 10 }
          ]
          // payments: [1, 3, 5, 10]
        },
        {
          minAge: 56,
          maxAge: 60,
          payments: [
            { name: "一次交清", value: 1 },
            { name: "3年", value: 3 },
            { name: "5年", value: 5 }
          ]
          // payments: [1, 3, 5]
        },
        {
          minAge: 61,
          maxAge: 65,
          payments: [{ name: "一次交清", value: 1 }]
          // payments: [1]
        }
      ],
      selectaddCoverage: null,
      addCoverage: [{ name: "100", value: 100 }, { name: "200", value: 200 }], //医疗-首年保费
      social: [{ name: "有社保", value: 1 }, { name: "无社保", value: 0 }],
      selectSocial: null
    };
  },

  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    date: function() {
      let age = this.getAgeByStr(this.date);
      if (age === 0) {
        return false;
      }

      if (age > 65) {
        alert("被保险人年龄超过65岁，无法投保");
        this.date = "";
        return false;
      }
      // if (60 < age < 65) {
      //   this.isdisabled = true;
      // } else {
      //   this.isdisabled = false;
      // }
    },
    sex: function(val) {
      this.sexChange(val);
    },
    coverage: function(val) {
      this.coverageChange(val);
    },
    payment: function(val) {
      this.paymentChange(val);
    },
    addCoverage: function(val) {
      this.addCoverageChange(val);
    },
    social: function(val) {
      this.SocialChange(val);
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.initpayment(date);
      this.initcoverage(date);
      this.getPrice();
      this.getAddPrice();
    },
    //保障额度
    initcoverage() {
      let age = this.getAgeByStr(this.date); //获取年龄
      let matches = this.coverageByAge.find(
        item => age >= item.minAge && age <= item.maxAge
      );
      if (matches !== undefined) {
        this.coverage = this.coverages.filter(
          item => item >= matches.minCoverage && item <= matches.maxCoverage
        );
        if (matches.maxAge == 50) {
          Vue.set(this.coverage, 5, 28);
        }
        if (matches.maxAge == 65) {
          Vue.set(this.coverage, 2, 12);
        }
        //console.log(this.coverage);
      }
    },
    //交费期限
    initpayment() {
      // this.selectPayment=null;
      // this.payment=[];
      let age = this.getAgeByStr(this.date);
      let matchPayments = this.paymentByAge.find(
        item => age >= item.minAge && age <= item.maxAge
      );
      let enabledPayments = [];
      if (matchPayments !== undefined) {
        enabledPayments = matchPayments.payments || [];
      } else {
        enabledPayments = this.paymentByAge.payments;
      }
      this.payment = enabledPayments;
      //console.log(this.payment);
    },
    addCoverageChange(val) {
      let age = this.getAgeByStr(this.date);
      if (age > 60) {
        return false;
      }
      this.selectaddCoverage = val;
      // console.log(this.selectaddCoverage);
      this.getAddPrice();
    },
    SocialChange(val) {
      this.selectSocial = val;
      // console.log(this.selectSocial);
      this.getAddPrice();
    },
    sexChange(val) {
      this.selectSex = val;
      // console.log("selectSex" + this.selectSex);
      this.getPrice();
    },
    coverageChange(val) {
      this.selectCoverage = val;
      this.getPrice();
      //console.log("selectCoverage" + this.selectCoverage);
    },
    paymentChange(val) {
      this.selectPayment = val;
      this.getPrice();
      // console.log("selectPayment" + this.selectPayment);
    },
    //计算保费
    getPrice() {
      this.price = "--------";
      //年龄
      let age = this.getAgeByStr(this.date);
      if (age < 60) {
        this.isdisabled = false;
      }
      //读取json数据 算保费
      let jsonData = [];
      let resData = [];
      let listData = [];
      let resRate = null;
      //let resData=[];
      this.$axios.get("/json/salaryjson/premiumRate.json").then(res => {
        jsonData = res;
        resData = jsonData.find(function(val) {
          return val.age === age;
        });
        // console.log(Number(this.selectPayment));
        //  return;
        if (Number(this.selectPayment) && this.selectSex != null) {
          // console.log(resData);
          let p = this.selectPayment;
          for (let key in resData) {
            if (key === "list") {
              var arrList = resData[key];
              listData = arrList.find(function(val) {
                return val.payments === p;
              });
              // console.log(listData);
            }
          }
          let s = this.selectSex;
          for (let key in listData) {
            if (key === "rates") {
              var rateArr = listData[key];
              resRate = rateArr.find(function(val) {
                return val.sex === s;
              });
            }
          }
          //计算费率
          let resPrice = Math.round(
            Number(this.selectCoverage) * 10 * Number(resRate.rate)
          );
          if (Number(resPrice)) {
            if (this.selectPayment != 1) {
              this.price = resPrice.toFixed(2) + "/年";
            } else {
              this.price = resPrice.toFixed(2);
            }
          } else {
            this.price = "--------";
          }
        }
      });
    },
    getAddPrice() {
      let age = this.getAgeByStr(this.date);
      if (age > 60) {
        this.addprice = "--------";
        this.isdisabled = true;
        return;
      }
      let jsonData2 = [];
      let resData2 = [];
      let resRate2 = null;
      this.$axios.get("/json/salaryjson/addRisksRate.json").then(res => {
        jsonData2 = res.find(function(val) {
          return val.age === age;
        });

        if (Number(this.selectaddCoverage)) {
          let cov = this.selectaddCoverage;
          for (let key in jsonData2) {
            if (key === "data") {
              var arrList = jsonData2[key];
              resData2 = arrList.find(function(val) {
                return val.coverage === cov;
              });
              //console.log(resData2);
            }
          }
          let ss = this.selectSocial;
          for (let key in resData2) {
            if (key === "rates") {
              resRate2 = resData2[key].find(function(val) {
                return val.social === ss;
              });
            }
          }
          //计算费率
          if (this.selectSocial != null) {
            this.addprice = resRate2.rate.toFixed(2);
          } else {
            this.addprice = "--------";
          }
        }
      });
    },
    //获取年龄
    getAgeByStr(str, days) {
      if (str == null) {
        return 0;
      }
      let arr = str.split("-");
      let birthObj = {
        year: Number(arr[0]),
        month: Number(arr[1]),
        date: Number(arr[2])
      };
      var now = new Date();
      var age = now.getFullYear() - birthObj.year;
      if (age < 0) {
        return 0;
      }
      var todayMonth = now.getMonth() + 1;

      if (todayMonth < birthObj.month) {
        age--;
      } else if (todayMonth === birthObj.month) {
        if (now.getDate() < birthObj.date) {
          age--;
        }
      }
      // 出生小于30天返回-1
      if (
        age === 0 &&
        now.getFullYear() === birthObj.year &&
        todayMonth === birthObj.month
      ) {
        let num = days || 30;
        if (now.getDate() - birthObj.date < num) {
          return -1;
        }
      }
      return age;
    }
  }
};
</script>
<style lang="scss">
#trial {
  .v-menu__content {
    left: 0 !important;
  }
  .v-picker__title {
    height: 10px !important;
  }
  .v-input {
    .v-input__control {
      .v-input__slot {
        .v-select__slot {
          .v-label {
            width: 170px !important;
            margin-top: 0px;
          }
        }
        .v-menu {
          .v-menu__content {
            top: 10px !important;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.form-item {
  width: 164px;
}
</style>
